import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Header, Icon, Button, Grid, Message, List, Label } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import Input from '../Forms/Input'
import ClientsStore from '../../stores/ClientsStore'
import Select from '../Forms/Select'

@observer
class clientPrincipalInformation extends Component {
  static propTypes = {
    clientsStore: PropTypes.instanceOf(ClientsStore),
    canEdit: PropTypes.bool,
    editMode: PropTypes.bool,
    canSendEmailLogin: PropTypes.bool,
    activateEdit: PropTypes.func
  }

  static defaultProps = {
    canEdit: false,
    canSendEmailLogin: false
  }

  state = { sending: false, error: false, errorMessage: '' }

  handleSendEmailLogin = () => {
    const { clientsStore } = this.props
    this.setState({ sending: true })
    clientsStore.sendEmailLogin(clientsStore.client.id).then(() => {
      this.setState({ sending: false })
    }).catch(e => {
      this.setState({
        sending: false,
        error: true,
        errorMessage: e.message
      })
    })
  }

  render () {
    const { clientsStore, canEdit, canSendEmailLogin, activateEdit, editMode } = this.props
    const { sending, error, errorMessage } = this.state
    return (
      <>
        {(sending || error) &&
          <Message
            error={error} icon
            onDismiss={error ? () => { this.setState({ error: false, errorMessage: false }) } : undefined}
          >
            {!error && <Icon name='circle notched' loading />}
            <Message.Content>
              {!error &&
                <>
                  <Message.Header>Envoi en cours</Message.Header>
                  Envoi du courriel en cours...
                </>}
              {error &&
                <>
                  <Message.Header>Erreur d'envoi</Message.Header>
                  {errorMessage}
                </>}
            </Message.Content>
          </Message>}
        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column>
              <List>
                <List.Item>
                  <Header as='h2' floated='left'>
                    Informations Principales {clientsStore.client.clients_synced_id &&
                      <Label color='blue'>Lié avec ServiCentre</Label>}
                  </Header>
                </List.Item>
                {activateEdit &&
                  <List.Item>
                    <Button icon color={editMode ? 'green' : undefined} disabled={editMode} onClick={activateEdit}>
                      <Icon
                        name={editMode ? 'check' : 'pencil'}
                      /> {editMode ? 'Modification activé' : 'Modifier client'}
                    </Button>
                  </List.Item>}
              </List>
            </Grid.Column>
            {canSendEmailLogin &&
              <Grid.Column>
                <Button floated='right' icon primary onClick={this.handleSendEmailLogin}>
                  <Icon name='send' />
                  Envoyer info connexion
                </Button>
              </Grid.Column>}
          </Grid.Row>
          {clientsStore.client.clients_synced_id && editMode &&
            <Grid.Row>
              <Grid.Column>
                <Message warning content='Attention, ce client est lié avec ServiCentre! Toute modification pourrait être remplacée par le contenu venant de ServiCentre.' />
              </Grid.Column>
            </Grid.Row>}
          <Grid.Row>
            <Grid.Column>
              {clientsStore.client &&
                <Form>
                  <Form.Group widths='equal'>
                    <Input name='client.name' store={clientsStore} label='Nom de la société' readOnly={!canEdit} />
                    <Select
                      name='client.type' store={clientsStore} label='Type de client' readOnly={!canEdit}
                      options={[{ value: 'private', text: 'Privé' }, { value: 'organization', text: 'Organisme' }]}
                    />
                  </Form.Group>
                  <Input
                    name='client.activity_field' store={clientsStore} label="Domaine d'activité"
                    readOnly={!canEdit}
                  />
                  <Form.Group widths='equal'>
                    <Input name='client.contact_name' store={clientsStore} label='Nom contact' readOnly={!canEdit} />
                    <Input
                      name='client.contact_title' store={clientsStore} label='Titre du contact'
                      readOnly={!canEdit}
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Input
                      name='client.tel_cellphone' store={clientsStore} label='Numéro mobile'
                      readOnly={!canEdit}
                    />
                    <Input name='client.contact_email' store={clientsStore} label='Courriel' readOnly={!canEdit} />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Input
                      name='client.tel_office' store={clientsStore} label='Numéro de téléphone'
                      readOnly={!canEdit}
                    />
                    <Input
                      name='client.tel_fax' store={clientsStore} label='Numéro de télécopieur'
                      readOnly={!canEdit}
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Input name='client.tel_other' store={clientsStore} label='Autre numéro' readOnly={!canEdit} />
                    <Input name='client.website' store={clientsStore} label='Site web' readOnly={!canEdit} />
                  </Form.Group>
                </Form>}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    )
  }
}

export default clientPrincipalInformation
